import { Builder } from '@builder.io/react';
import { builder } from '@builder.io/react';
import React, { useEffect, useState } from 'react';
import sanitizeHtml from 'sanitize-html';

import { Text } from '../../storyblocks-design-system/components/atoms/Text/Text';

const fetchContent = async (urlPath: string, modelName: string) => {
  const builderApiResponse = await builder.get(modelName, {
    query: {
      name: urlPath,
    },
  });

  return (
    builderApiResponse?.data || {
      richTextHeader: '',
      richTextContent: '',
    }
  );
};

export const RichText = ({
  urlPath,
  modelName = 'category-search-page',
  altHeader,
  altContent,
}: {
  urlPath?: string;
  modelName?: string;
  altHeader?: string;
  altContent?: string;
}) => {
  const [richTextHeader, setRichTextHeader] = useState('');
  const [richTextContent, setRichTextContent] = useState('');

  useEffect(() => {
    if (!urlPath || !modelName) {
      setRichTextHeader(altHeader);
      setRichTextContent(altContent);
      return;
    }

    const getContent = async () => {
      const { richTextHeader, richTextContent } = await fetchContent(
        urlPath,
        modelName
      );

      setRichTextHeader(richTextHeader || altHeader);
      setRichTextContent(richTextContent || altContent);
    };
    getContent();
  }, [urlPath, modelName]);

  if (!richTextContent && !richTextHeader) return null;

  // Leaving a very strict sanitize config here to prevent XSS attacks and weird HTML
  const sanitizeConfig: sanitizeHtml.IOptions = {
    allowedTags: ['b', 'i', 'em', 'strong', 'a'],
    allowedAttributes: {
      a: ['href', 'target', 'rel'],
    },
    allowedSchemes: ['http', 'https', 'mailto'],
  };

  const sanitizedRichTextContent = sanitizeHtml(
    richTextContent,
    sanitizeConfig
  );
  const sanitizedRichTextHeader = sanitizeHtml(richTextHeader, sanitizeConfig);

  return (
    <div className="flex flex-col gap-2 items-center justify-center max-w-[483px] mx-auto">
      {richTextHeader && (
        <Text
          fontFamily="inter"
          fontWeight="semibold"
          fontSize="3xl"
          className="text-neutral-900 text-center text-3xl"
          asChild
        >
          <h1 dangerouslySetInnerHTML={{ __html: sanitizedRichTextHeader }} />
        </Text>
      )}
      {richTextContent && (
        <Text
          fontFamily="inter"
          fontSize="base"
          fontWeight="regular"
          className="text-neutral-900 text-center text-base mt-0"
          asChild
        >
          <h2 dangerouslySetInnerHTML={{ __html: sanitizedRichTextContent }} />
        </Text>
      )}
    </div>
  );
};

export default RichText;

Builder.registerComponent(RichText, {
  name: 'RichText SB',
  inputs: [],
});
